module.exports = __webpack_public_path__ + "static/media/success_green.c33266cc.svg";